import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { IReject, IResolve } from '@df/api/request/request.service';
import { App } from '@df/core/app';
import { Customer } from '@df/session/api/customer';
import { NSession } from '../df-session.config';

declare module '@angular/router' {
    interface ActivatedRouteSnapshot {
        preventRedirect?: boolean;
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerLoggedGuard implements CanActivate {
    private moduleConfig = inject(NSession.OPTIONS);

    constructor(protected router: Router, protected customer: Customer, protected app: App) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise<boolean>((resolve: IResolve, reject: IReject) => {
            return this.customer.model
                .load()
                .then(() => {
                    if (this.isCustomerAllowed()) {
                        resolve(true);
                    } else {
                        if (!next.preventRedirect) {
                            this.onError();
                        }
                    }
                })
                .catch(reject);
        });
    }

    isCustomerAllowed(): boolean {
        return this.customer.model.isLoggedIn;
    }

    onError(): void {
        this.router.navigate([this.moduleConfig.onCustomerLoggedGuardErrorUrl]);
    }
}
